// Só o plano free tem rótulo/lista próprios no app: os planos pagos vêm de
// `billing.plano.plano_chave` (constants/billing.ts) e os limites reais dos
// tiers pagos do catálogo do backend.
export const planDetails = {
  free: {
    title: "Plano Básico",
    shortTitle: "Básico",
    description: "Acesso gratuito com recursos limitados.",
    features: ["Até 3 pacotes de cirurgia", "Até 3 pacotes de OPME"],
    headerClass: "bg-gradient-to-br from-[#dde3ff] to-[#f0f2ff] text-[#2f3d7e]",
    chipClass: "bg-[#dde3ff] text-[#2f3d7e]",
    dotClass: "bg-[#4b73ff]",
  },
};
